<template>
    <div class=""> 
        <header>
            <div class="w3-container">
                <h4 class="page-title">ÚTVONALKÍNÁLAT</h4>
                <div class="w3-margin-top">
                    <span v-on:click="isShowFilter=true" class="w3-right cursorpointer w3-text-blue"><font-awesome-icon class="" size="1x" icon="filter"></font-awesome-icon> SZŰRÉS</span>
                    <span v-if="view[0]" v-on:click="changeView(0)" class="cursorpointer w3-padding w3-green w3-hover-white">KÁRTYA</span>
                    <span v-else v-on:click="changeView(0)" class="cursorpointer w3-padding theme-1 w3-hover-white">KÁRTYA</span>
                    <span v-if="view[1]" v-on:click="changeView(1)" class="cursorpointer w3-padding w3-green w3-hover-white">LISTA</span>
                    <span v-else v-on:click="changeView(1)" class="cursorpointer w3-padding theme-1 w3-hover-white">LISTA</span>
                    <span v-on:click="changeView(2)" class="cursorpointer w3-padding theme-1 w3-hover-white">TÉRKÉP</span>            

                    <!--
                    <button v-on:click="changeView(0)" class="w3-button w3-white" :class="{ 'w3-black': view[0] }">KÁRTYA</button>
                    <button v-on:click="changeView(1)" class="w3-button w3-white" :class="{ 'w3-black': view[1] }">LISTA</button>
                    <button v-on:click="changeView(2)" class="w3-button w3-white" :class="{ 'w3-black': view[2] }">TÉRKÉP</button>            
                    -->
                    <hr class="theme-1" style="height:5px;">
                </div>
            </div>
        </header>
        <div v-if="geogoList">
            <div v-if="view[0]" class="w3-row-padding w3-margin-top">
                <div v-for="(item, index) in orderedAndFilteredList" :key="index" class="w3-third w3-container w3-margin-bottom">
                    <img :src="item.imgUrl" style="width:100%" class="w3-card-2">
                    <div class="w3-container box-color">                 
                        <div class="w3-margin-top">
                            <div class="w3-right route-title">
                                <span v-if="item.mode=='2'"><font-awesome-icon icon="bicycle" ></font-awesome-icon></span>
                                <span v-if="item.mode=='1'"><font-awesome-icon icon="hiking" ></font-awesome-icon></span>                            
                            </div>
                            <div class="route-title"><b>{{item.name}}</b></div>
                        </div>
                        <div class="w3-margin-bottom">[{{item.district}}]</div>
                        <div class="w3-margin-bottom">
                            <font-awesome-icon icon="route"></font-awesome-icon> {{item.distance}} km / <font-awesome-icon icon="angle-up" ></font-awesome-icon> {{item.level}} m
                            <div class="w3-right"><font-awesome-icon icon="dollar-sign"></font-awesome-icon> {{item.price}} {{$appData.currency}}</div>
                        </div>
                        <div class="w3-justify " style="overflow: hidden; height:100px">{{item.description | filterTruncate(100)}}</div>
                        <div class="w3-margin-bottom w3-margin-top">
                            <div class="w3-center">
                               <button v-on:click="showRoute(item)" class="w3-margin-right w3-button w3-border w3-border-green w3-green w3-hover-white" style="width:100px;">Részletek</button>                        
                                <Entry v-bind:route="item"></Entry>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="view[1]" class="w3-row-padding w3-container">
                <table class="w3-table-all w3-card-4 w3-small w3-padding">
                    <tr class="theme-1">
                        <td class="w3-hide-small">#</td>                                         
                        <td class=""></td>                        
                        <td class=""></td> 
                        <td v-on:click="sortBy('name')" class="cursorpointer">
                            Név
                            <font-awesome-icon v-if="sortKey=='name' && reverse=='desc'" icon="angle-up"></font-awesome-icon>
                            <font-awesome-icon v-if="sortKey=='name' && reverse=='asc'" icon="angle-down"></font-awesome-icon>
                        </td>
                        <td v-on:click="sortBy('type')" class="w3-center cursorpointer w3-hide-small">                    
                            <font-awesome-icon v-if="sortKey=='type' && reverse=='desc'" icon="angle-up"></font-awesome-icon>
                            <font-awesome-icon v-if="sortKey=='type' && reverse=='asc'" icon="angle-down"></font-awesome-icon>                                
                        </td>                 
                        <td v-on:click="sortBy('landscape')" class="cursorpointer w3-hide-small w3-center">
                            Tájegység
                            <font-awesome-icon v-if="sortKey=='landscape' && reverse=='desc'" icon="angle-up"></font-awesome-icon>
                            <font-awesome-icon v-if="sortKey=='landscape' && reverse=='asc'" icon="angle-down"></font-awesome-icon>                                
                        </td>
                        <td v-on:click="sortBy('distance')" class="w3-center cursorpointer ">
                            Táv
                            <font-awesome-icon v-if="sortKey=='distance' && reverse=='desc'" icon="angle-up"></font-awesome-icon>
                            <font-awesome-icon v-if="sortKey=='distance' && reverse=='asc'" icon="angle-down"></font-awesome-icon>                                
                        </td>  
                        <td v-on:click="sortBy('level')" class="w3-center cursorpointer w3-hide-small">
                            Szint
                            <font-awesome-icon v-if="sortKey=='level' && reverse=='desc'" icon="angle-up"></font-awesome-icon>
                            <font-awesome-icon v-if="sortKey=='level' && reverse=='asc'" icon="angle-down"></font-awesome-icon>                                
                        </td>  
                        <td v-on:click="sortBy('price')" class="w3-center cursorpointer w3-hide-small">
                            Ár
                            <font-awesome-icon v-if="sortKey=='price' && reverse=='desc'" icon="angle-up"></font-awesome-icon>
                            <font-awesome-icon v-if="sortKey=='price' && reverse=='asc'" icon="angle-down"></font-awesome-icon>                                
                        </td>  
                    </tr>                                           
                    <tr class="cursorpointer" v-for="(item, index) in orderedAndFilteredList" :key="index" v-on:click="showRoute(item)">
                        <td class="w3-hide-small" style="vertical-align: middle;">{{index+1}}.</td>
                        <td class="" style="width:100px">
                            <img :src="item.imgUrl" style="width:100px" class="w3-border">
                        </td>                                                             
                        <td class="w3-center" style="vertical-align: middle;">                            
                        <span v-if="item.mode=='2'"><font-awesome-icon icon="bicycle" ></font-awesome-icon></span>
                        <span v-if="item.mode=='1'"><font-awesome-icon icon="hiking" ></font-awesome-icon></span>
                        </td> 
                        <td class="uppercase" style="vertical-align: middle;">{{item.name}}</td>
                        <td class="w3-hide-small w3-center" style="vertical-align: middle;">
                        <font-awesome-icon v-if="item.type=='1'" icon="redo-alt" ></font-awesome-icon>
                        <font-awesome-icon v-if="item.type=='2'" icon="minus" ></font-awesome-icon>              
                        </td>                                                    
                        <td class="w3-hide-small w3-center" style="vertical-align: middle;">{{item.landscape | filterLandscapeToString}}</td>                    
                        <td class="w3-center" style="vertical-align: middle;">{{item.distance}} km</td>                                        
                        <td class="w3-center w3-hide-small" style="vertical-align: middle;">{{item.level}} m</td>                
                        <td class="w3-center w3-hide-small" style="vertical-align: middle;">{{item.price}} {{$appData.currency}}</td>                
                    </tr>
                </table> 
		    </div>
        </div>

        <div v-if="isShowFilter" class="w3-modal" style="z-index: 4000; display:block;">
            <div class="w3-modal-content w3-card-4 w3-animate-zoom">
                <div class="w3-display-container">
                    <div class="w3-blue">
                        <h3 class="w3-padding">Szűrési beállítások</h3>
                    </div>
                    <div class="w3-padding">
                        <div class="w3-margin-right">
                            <label class="w3-text-blue">Túra neve</label>
                            <input class="w3-input w3-border w3-light-grey" v-model="filter.name">                         
                        </div>
                        <div class="w3-row">
                            <div class="w3-half w3-mobile">
                                <div class="w3-margin-right w3-margin-top">
                                    <label class="w3-text-blue">Tájegység</label>
                                    <select class="w3-select w3-border w3-light-grey" v-model="filter.landscape">
                                        <option v-for="(item, index) in $appData.landscape" :key="index" v-bind:value="item.id">{{item.name}}</option>
                                    </select>   
                                </div>                
                            </div> 
                            <div class="w3-half w3-mobile">
                                <div class="w3-margin-right w3-margin-top">
                                    <label class="w3-text-blue">Járás</label>
                                    <select class="w3-select w3-border w3-light-grey" v-model="filter.district">
                                        <option v-for="(item, index) in $appData.districts" :key="index" v-bind:value="item">{{item}}</option>
                                    </select>   
                                </div>
                            </div>  
                        </div>
                        <div class="w3-row">
                            <div class="w3-half w3-mobile">
                                <div class="w3-margin-right w3-margin-top">
                                    <label class="w3-text-blue">Típus</label>
                                    <select class="w3-select w3-border w3-light-grey" v-model="filter.type">
                                        <option value=""></option>
                                        <option v-for="(item, index) in $appData.type" :key="index" v-bind:value="item.sign">{{item.name}}</option>
                                    </select>   
                                </div>                
                            </div> 
                            <div class="w3-half w3-mobile">
                                <div class="w3-margin-right w3-margin-top">
                                    <label class="w3-text-blue">Teljesítés módja</label>
                                    <select class="w3-select w3-border w3-light-grey" v-model="filter.mode">
                                        <option value=""></option>                                       
                                        <option v-for="(item, index) in $appData.mode" :key="index" v-bind:value="item.sign">{{item.name}}</option>
                                    </select>                
                                </div>
                            </div>  
                        </div>
                        <div class="w3-row">
                            <div class="w3-half w3-mobile">
                                <div class="w3-margin-right w3-margin-top">
                                    <label class="w3-text-blue">Minimális táv (km)</label>
                                    <input v-model="filter.minDistance" type="number" class="w3-input w3-border w3-light-grey">
                                </div>                
                            </div> 
                            <div class="w3-half w3-mobile">
                                <div class="w3-margin-right w3-margin-top">
                                    <label class="w3-text-blue">Maximális táv (km)</label>
                                    <input v-model="filter.maxDistance" type="number" class="w3-input w3-border w3-light-grey" >                         
                                </div>
                            </div>  
                        </div>
                    </div>
                </div>
                <div class="w3-container w3-light-grey w3-padding">
                    <!--<button class="w3-button w3-right w3-green w3-margin-left" v-on:click="saveInfo">Mentés</button>-->
                    <button class="w3-button w3-right w3-green w3-margin-left" v-on:click="isShowFilter=false">Bezárás</button>
                </div>
            </div> 
        </div> 
    </div>
</template>

<script>
const fb = require('../firebase.js');
import Entry from '../components/Entry.vue';
export default {
    name: 'Routes',
    data() {
        return {
            view:[true,false,false],
            geogoList: null,
            sortKey: 'name',
            reverse: 'asc',
            hikeListCount:0,
            markers:null,
            isShowFilter:false,
            filter:{
                "name":"",
                "district":"",
                "landscape":"",
                "mode":"",
                "type":"",
                "minDistance":0,
                "maxDistance":500
            }, 
        }
    }, 
    components: {
      Entry
    },    
    computed: {   
        orderedAndFilteredList: function () {
            var orderedList=_.orderBy(this.geogoList, [this.sortKey], [this.reverse]);
            if ((this.sortKey)=='name' && (this.reverse=='asc'))
            orderedList.sort(function(a, b) {
                return a.name.localeCompare(b.name);
            });
            if ((this.sortKey)=='name' && (this.reverse=='desc'))
            orderedList.sort(function(a, b) {
                return b.name.localeCompare(a.name);
            });        
            var filteredList = orderedList.filter((item) => {    
                const nameFilter = (item.name.toLowerCase().indexOf(this.filter.name.toLowerCase())>-1);
                const districtFilter = (item.district.toLowerCase().indexOf(this.filter.district.toLowerCase())>-1);
                const landFilter = (item.landscape==this.filter.landscape) || (this.filter.landscape=="") || (this.filter.landscape=="cs-0");
                const typeFilter = (item.type==this.filter.type) || (this.filter.type=="");
                const modeFilter = (item.mode==this.filter.mode) || (this.filter.mode=="");
                const minDistFilter = (item.distance>=this.filter.minDistance) || (this.filter.minDistance=="");
                const maxDistFilter = (item.distance<=this.filter.maxDistance) || (this.filter.maxDistance=="");
                return nameFilter && districtFilter && landFilter && typeFilter && modeFilter && minDistFilter && maxDistFilter;
            });                     
            this.hikeListCount=Object.keys(filteredList).length;
            return filteredList;
        }
    }, 
    mounted: function(){
        this.view = this.$storage.get('routeView', [true,false,false]);
        this.$showSpinner();
        fb.GetGeogoList().then(res=>{
            this.geogoList = res;
            this.setMarkers(res);
            this.$hideSpinner();
            if (this.view[2]) {
                this.$router.push({ name: 'mainmap', params: { source: 'allRoute', markers:this.markers }});            
            }            
        }).catch(e=>{
            this.$hideSpinner();
            this.$dialog.alert(this.$setDialogMsg('w3-red','Hibaüzenet','Hiba történt az adatok betöltése során.'));
        });  
    },
    methods:{
        sortBy(sortKey) {
        if (this.sortKey == sortKey) {
            if (this.reverse=='asc') this.reverse='desc';
            else this.reverse='asc';
        };
        this.sortKey = sortKey;
        },   
        setMarkers(res){
            try{
                var markers=[];
                Object.keys(res).map(function(objectKey, index) {          
                    var value = res[objectKey];              
                    if (value.status=="2") {
                        var iconColor=2;
                        var marker = { "position": { "lng": value.lat, "lat": value.lon }, "visible": true, "id": value.id, "iconColor":iconColor, "allInfo":value };
                        markers.push(marker);
                    }          
                });
                this.markers = markers;
            }catch(e) {
                console.log(e);
            }
        },
        changeView(i){
            this.view=[false,false,false];
            this.view[i]=true;
            this.$storage.set('routeView', this.view);
            if (i==2) {
                this.$router.push({ name: 'mainmap', params: { source: 'allRoute', markers:this.markers }});            
            }
        },        
        showRoute(item){
            this.$router.push('/routeinfo/'+item.id);
        }
    }      
  }
  </script>